(function () {
  function launchConfetti() {
    const canvas = document.createElement('canvas');
    canvas.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:9999';
    document.body.appendChild(canvas);

    const ctx = canvas.getContext('2d');
    const W = canvas.width = window.innerWidth;
    const H = canvas.height = window.innerHeight;

    const colors = ['#00762d', '#215f51', '#4caf82', '#f5c518', '#ffffff', '#a8e8e2', '#ff914d'];
    const pieces = Array.from({ length: 130 }, function (_, i) {
      var left = i < 65;
      return {
        x:       left ? W * 0.22 : W * 0.78,
        y:       H + 10,
        color:   colors[i % colors.length],
        w:       7  + Math.random() * 8,
        h:       4  + Math.random() * 5,
        circle:  Math.random() < 0.3,
        vx:      (left ? 1 : -1) * (2 + Math.random() * 5),
        vy:      -(9 + Math.random() * 10),
        angle:   Math.random() * Math.PI * 2,
        spin:    (Math.random() - 0.5) * 0.28,
        gravity: 0.14 + Math.random() * 0.06,
        opacity: 1
      };
    });

    var raf;
    function draw() {
      ctx.clearRect(0, 0, W, H);
      var alive = 0;
      pieces.forEach(function (p) {
        p.x += p.vx;
        p.y += p.vy;
        p.vy += p.gravity;
        p.vx *= 0.992;
        p.angle += p.spin;
        if (p.y > H * 0.65) p.opacity = Math.max(0, p.opacity - 0.018);
        if (p.opacity > 0 && p.y < H + 20) {
          alive++;
          ctx.save();
          ctx.translate(p.x, p.y);
          ctx.rotate(p.angle);
          ctx.globalAlpha = p.opacity;
          ctx.fillStyle = p.color;
          if (p.circle) {
            ctx.beginPath();
            ctx.arc(0, 0, p.w / 2, 0, Math.PI * 2);
            ctx.fill();
          } else {
            ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
          }
          ctx.restore();
        }
      });
      if (alive > 0) {
        raf = requestAnimationFrame(draw);
      } else {
        canvas.remove();
      }
    }

    raf = requestAnimationFrame(draw);
    setTimeout(function () { cancelAnimationFrame(raf); canvas.remove(); }, 5500);
  }

  // --- State ---
  var SS_KEY    = 'oley_fs_eligible';
  var THRESHOLD = window.oleyFSThresholdCents || 3000;
  var cooldown  = false;

  function getStored() {
    // null  = first visit this session (never recorded)
    // '1'   = was eligible
    // '0'   = was not eligible
    return sessionStorage.getItem(SS_KEY);
  }
  function setStored(eligible) {
    sessionStorage.setItem(SS_KEY, eligible ? '1' : '0');
  }

  function fire() {
    if (cooldown) return;
    cooldown = true;
    launchConfetti();
    setTimeout(function () { cooldown = false; }, 6000);
  }

  // Core: given the resolved eligibility, decide whether to fire confetti.
  function maybeFireConfetti(isEligible) {
    var stored = getStored();
    var wasEligible = stored === '1';

    // Only fire when crossing from ineligible → eligible.
    // On the very first visit this session (stored === null) we never fire —
    // we just record the baseline so subsequent transitions work correctly.
    if (stored !== null && isEligible && !wasEligible) {
      fire();
    }

    setStored(isEligible);
  }

  // Check via DOM when the free-shipping banner is present on this page.
  function checkViaDOM() {
    maybeFireConfetti(!!document.querySelector('.free-shipping__text--success'));
  }

  // Check via /cart.js when the banner isn't in the DOM (product pages, etc.).
  function checkViaFetch() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        maybeFireConfetti(cart.total_price >= THRESHOLD);
      })
      .catch(function () {});
  }

  function checkAndFire() {
    if (document.querySelector('.free-shipping')) {
      // Banner is in the DOM — read it directly (no fetch needed).
      checkViaDOM();
    } else {
      // Banner not rendered on this page (product page, collection, etc.).
      checkViaFetch();
    }
  }

  // Cart page: fires after .js-contents DOM swap completes.
  document.addEventListener('cart:updated', function () {
    setTimeout(checkAndFire, 80);
  });

  // Mini-cart / add-to-cart: MutationObserver catches the success element appearing.
  var mo = new MutationObserver(function () {
    if (getStored() !== '1' && document.querySelector('.free-shipping__text--success')) {
      maybeFireConfetti(true);
    }
  });

  function init() {
    // Record baseline state without firing (first visit baseline).
    // If we navigated here from another page and the state already crossed,
    // maybeFireConfetti will detect the stored '0' → current true transition.
    checkAndFire();
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
